const options = [
    {
        "ID": 1,
        "NOMBRE": "VERIFICADA",
        "VALUE": 8
    },
    {
        "ID": 2,
        "NOMBRE": "RENOMBRADA",
        "VALUE": 1
    }
]

export default options;